import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=70d5bdde&scoped=true&"
import script from "./qrCode.vue?vue&type=script&lang=js&"
export * from "./qrCode.vue?vue&type=script&lang=js&"
import style0 from "./qrCode.vue?vue&type=style&index=0&id=70d5bdde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5bdde",
  null
  
)

export default component.exports